var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sidebar--shop" },
    [
      _c("ShopSearchBar"),
      _vm._v(" "),
      _c("FilterGroup", {
        attrs: {
          taxonomy: "category",
          name: _vm.categoriesText,
          terms: _vm.categories,
        },
      }),
      _vm._v(" "),
      _vm._l(_vm.attributes, function (attribute) {
        return _c("FilterGroup", {
          key: attribute.slug,
          attrs: {
            name: attribute.name,
            taxonomy: attribute.slug,
            terms: attribute.terms,
          },
        })
      }),
      _vm._v(" "),
      _c("CapacitySlider"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }